import InvestMoreContainer from "./InvestMoreContainer";
import InvestMoreStore from "./InvestMoreStore";

export default InvestMoreStore(InvestMoreContainer);